export const confirmCode = (payload: string) => ({
  type: "@saga/CONFIRM_CODE",
  payload,
});
